const escapeUrlComponent = component => (
    component
        .replace("/", "£")
        .replace("+", "_")
        .replace(" ", "%20")
)

const unEscapeUrlComponent = component => (
    component
        .replace("£", "/")
        .replace("_", "+")
        .replace("%20", " ")
)

export { unEscapeUrlComponent, escapeUrlComponent }
